// A page with no catalog behind it has no name in the store, so there is nothing to shorten.
export const extractCatalogName = (catalogName: string | null | undefined): string | undefined => {
	return catalogName?.split(":")?.[0]?.split("~")?.[0];
};
